import { render } from "./InnovationsByProjectTypeChart.vue?vue&type=template&id=111b2568"
import script from "./InnovationsByProjectTypeChart.vue?vue&type=script&lang=js"
export * from "./InnovationsByProjectTypeChart.vue?vue&type=script&lang=js"
script.render = render

export default script